import JuniChat from "@/components/JuniChat";

const Index = () => {
  return <JuniChat />;
};

export default Index;
